var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w_alert d_alert"},[_c('div',{staticClass:"w_alert_txt css_hack"},[_vm._v(_vm._s(_vm.alertpop_text))])])}
var staticRenderFns = []

export { render, staticRenderFns }